module.exports = __webpack_public_path__ + "img/certificate-3.04b88bb2.jpg";